import { useState } from "react";
import "../CSS/create-profit.css";
import { useServerError } from "../Utils/handleServerError";
import { useSelector } from "react-redux";
import StakeService from "../Services/StakeService";

const CreateStake = ({ handleOk, handleCancel, user_id }) => {
  const [form, setForm] = useState({});

  const { token } = useSelector((state) => state.authSlice);

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState(null);

  useServerError(error);

  const openErrorMessage = (error) => {
    setError(error);

    setTimeout(() => {
      setError(null);
    }, 4000);
  };

  const onChange = (key, val) => setForm((prev) => ({ ...prev, [key]: val }));

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!token || !form.coin || !form.amount || !form.duration || isNaN(form.rate)) {
      return;
    }

    setLoading(true);

    try {
      const res = await StakeService.create_stake(token, {
        ...form,
        user_id,
        amount: Number(form.amount),
        rate: Number(form.rate),
        duration: Number(form.duration)
      });

      handleOk(res.data || null);
    } catch (error) {
      openErrorMessage(error);
    }

    setLoading(false);
  };

  return (
    <div className="bv-create-profit-modal">
      <header>
        <h4>Add Stake</h4>
      </header>

      <form id="createStakeForm" className="body" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="coin" className="form-label">
            Coin
          </label>

          <select 
            className="form-control"
            name="coin" 
            id="coin"
            required
            value={form.coin || ""}
            onChange={(e) => onChange(e.target.name, e.target.value)}
          >
            <option value="" disabled>Select</option>
            <option value="Bitcoin">Bitcoin</option>
            <option value="Shiba">Shiba</option>
            <option value="Ether">Ether</option>
            <option value="Dogecoin">Dogecoin</option>
            <option value="Litecoin">Litecoin</option>
            <option value="BNB Coin">BNB Coin</option>
            <option value="LUNA Coin">LUNA Coin</option>
            <option value="NFT">NFT</option>
            <option value="ALGO Coin">ALGO Coin</option>
            <option value="TRX Coin">TRX Coin</option>
            <option value="Stellar (XLM)">Stellar (XLM)</option>
            <option value="XRP">XRP</option>
            <option value="BCH">BCH</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="amount" className="form-label">
            Amount
          </label>

          <input
            className="form-control"
            type="number"
            id="amount"
            required
            step={"0.01"}
            name="amount"
            value={form.amount || ""}
            onChange={(e) => onChange(e.target.name, e.target.valueAsNumber)}
            min={0.01}
          />
        </div>

        <div className="form-group">
          <label htmlFor="rate" className="form-label">
            Interest Rate (%)
          </label>

          <input
            className="form-control"
            type="number"
            id="rate"
            required
            step={"0.01"}
            name="rate"
            value={isNaN(form.rate) ? "" : form.rate}
            onChange={(e) => onChange(e.target.name, e.target.valueAsNumber)}
            min={0}
          />
        </div>

        <div className="form-group">
          <label htmlFor="duration" className="form-label">
            Duration (Days)
          </label>

          <input
            className="form-control"
            type="number"
            id="duration"
            required
            name="duration"
            value={form.duration || ""}
            onChange={(e) => onChange(e.target.name, e.target.valueAsNumber)}
            min={1}
          />
        </div>
      </form>

      <div className="actions">
        <button type="submit" disabled={loading} form="createStakeForm">
          {loading ? "..." : "Save"}
        </button>

        <button onClick={handleCancel}>Cancel</button>
      </div>
    </div>
  );
};

export default CreateStake;
